import { render } from "./ReturnLoads.vue?vue&type=template&id=350b6c48"
import script from "./ReturnLoads.vue?vue&type=script&lang=js"
export * from "./ReturnLoads.vue?vue&type=script&lang=js"

import "./ReturnLoads.vue?vue&type=style&index=0&id=350b6c48&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__